export default {
	appName: process.env.REACT_APP_NAME || 'eCallMe! Customer Engagement Solutions',
	appVersion: process.env.REACT_APP_PORTAL_VERSION || '0.0.0.1',
};
